import api from '../../services/api';
import { Prefix } from '../../services/prefix';
import Loading from '../../components/loader/loading';
import Swal from 'sweetalert2';
import React from 'react';

// Alertas padrão
export const alerts = [
  { value: 1, name: 'Sim, receber notificação' },
  { value: 0, name: 'Não receber notificação' }
];

// Verifica se o próximo campo pode ser habilitado 
export const isNextEnabled = prevValue => !!prevValue;

// Buscar UFs
export const fetchUFs = async (setUfOptions, setLoadingUFs) => {
  setLoadingUFs(true);
  try {
    const res = await api.get(`${Prefix.replace(/[\\"]/g, '')}/states`);
    const data = res.data?.models?.data?.map(uf => ({ value: uf.uf, label: uf.uf })) || [];
    setUfOptions(data);
  } catch (err) {
    console.error('Erro ao carregar estados:', err);
  } finally {
    setLoadingUFs(false);
  }
};

// Buscar cidades por UF
export const fetchCities = async (ufValue, setCityOptions, setLoadingCities) => {
  setLoadingCities(true);
  try {
    const res = await api.get(`${Prefix.replace(/[\\"]/g, '')}/cities?uf=${ufValue}`);
    const data = res.data?.models?.data?.map(c => ({ value: c.id, label: c.name })) || [];
    setCityOptions(data);
  } catch (err) {
    console.error('Erro ao carregar cidades:', err);
  } finally {
    setLoadingCities(false);
  }
};

// Registrar vínculo
export const handleRegister = async ({
  idUser, linkType, uf, city, unit, sector, room, contractItem, warning, danger, dark, setLoader, apiMutate
}) => {
  setLoader(<Loading />);
  const formData = {
    id_user: idUser,
    linkType: linkType?.value,
    uf: uf?.value,
    id_city: city?.value,
    id_unit: unit?.value,
    id_sector: sector?.value,
    id_room: room?.value,
    id_contract_item: contractItem?.value,
    warning: warning?.value,
    danger: danger?.value,
    dark: dark?.value
  };
  try {
    const res = await api.post(`${Prefix.replace(/[\\"]/g, '')}/contract-item-views`, formData);
    alertSuccess(res.data?.message);
    apiMutate();
  } catch (err) {
    alertError(err.response?.data?.message || 'Erro ao vincular');
  } finally {
    setLoader();
  }
};

// Excluir equipamentos
export const handleDelete = async (rows, listData, setLoader, apiMutate) => {
  setLoader(<Loading />);
  const ids = rows.map(r => listData?.data?.[r.dataIndex]?.id)
  for (const id of ids) {
    try {
      const res = await api.delete(`${Prefix.replace(/[\\"]/g, '')}/contract-item-views/${id}`);
      alertSuccess(res.data?.message);
      apiMutate();
    } catch (err) {
      alertError(err.response?.data?.message || 'Erro ao excluir');
    } finally {
      setLoader();
    }
  }
};

// Funções de alerta
export const alertSuccess = msg => Swal.fire({ icon: 'success', title: 'Uow!', text: msg, confirmButtonText: 'Fechar' });
export const alertError = msg => Swal.fire({ icon: 'error', title: 'Oops...', text: msg, confirmButtonText: 'Tentar novamente' });

// Gerar opções da tabela
export const getTableOptions = ({ pagina, perPage, listEquipmentView, HandleDelete, setPagina, setPerPage }) => ({
  draggableColumns: { enabled: true },
  serverSide: true,
  page: pagina,
  rowsPerPage: perPage,
  rowsPerPageOptions: [15, 30, 100],
  count: listEquipmentView.data?.models?.total || 0,
  expandableRows: false,
  onTableChange: (_, state) => {
    setPagina(state.page);
    setPerPage(state.rowsPerPage);
  },
  onSearchChange: text => console.log('Pesquisar:', text),
  onRowsDelete: rows => HandleDelete(rows.data, listEquipmentView.data?.models, () => { }, () => { }),
  customSearchRender: (text, handleSearch, hide, opts) => (
    <React.Fragment>
      {/* Pode colocar CustomSearchRender aqui se quiser */}
    </React.Fragment>
  ),
  searchPlaceholder: 'Pesquise um Equipamento',
  selectableRows: true,
  searchOpen: false
});
